import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../api";
import { getToken } from "../models/users.models";
import { ICreateProfile } from "../models/profiles.models";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const profilesConfig = {
  ...baseQueryConfig,
  baseUrl: baseQueryConfig.baseUrl + "/profiles",
  prepareHeaders: async (headers: Headers) => {
    let session = getToken();
    if (!session || !session.token) {
      await delay(500);
      session = getToken();
    }

    if (session && session.token) {
      headers.set("Authorization", `Bearer ${session.token}`);
    }

    return headers;
  },
};

export const profilesApi = createApi({
  reducerPath: "profilesApi",
  tagTypes: ["Profiles", "Users"],
  baseQuery: fetchBaseQuery(profilesConfig),
  endpoints: (builder) => ({
    getProfilesAvatars: builder.query<string[], void>({
      query: () => ({
        url: "/images/get-profile-images",
      }),
      providesTags: ["Profiles"],
    }),
    createProfile: builder.mutation<void, ICreateProfile>({
      query: (data) => ({
        url: "/create-profile",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Profiles", "Users"],
    }),
  }),
});

export const { useGetProfilesAvatarsQuery, useCreateProfileMutation } =
  profilesApi;

